import {Check} from "@sparkware/app-utils";
import {observer} from "mobx-react";
import {CyClass} from "../../../../common/cy-classes";
import {useServices} from "../../../react-hooks/use-services.hook";
import {LastLoginLabelBox} from "./boxes/last-login-label.box";
import {LastLoginValueBox} from "./boxes/last-login-value.box";

export const LastLoginComponent: React.FC = observer(() => {
    const services = useServices();
    if (Check.isNull(services.user.lastLogin)) {
        return null
    }

    return (
        <>
            <LastLoginLabelBox className={CyClass('cy-last-login-label')}>
                {services.translation.translate('LAST_LOGIN_TITLE')}
            </LastLoginLabelBox>
            <LastLoginValueBox className={CyClass('cy-last-login-value')}>
                {services.user.lastLogin}
            </LastLoginValueBox>
        </>
    )
})